import { AnomalyTrackingCommentSTO } from "src/models/tna/tna-anomalies/anomaly-tracking-comment-sto";
import { DTOModel } from "../../models/base/dto-model";
import { BaseApiService } from "../base";

export class SendAnomalyTrackingNotificationToEmployeesApiService extends BaseApiService<
  DTOModel,
  AnomalyTrackingCommentSTO
> {
  constructor() {
    super({
      servicePath: "/Anomaly",
      loadItemsPath: "",
      saveItemsPath: "/SendAnomalyTrackingNotificationToEmployees",
    });
  }
}
